<section class="hero wave-bg">
  <div class="container hero-content">
    <h1>
      Contactez
      <span class="accent"> Nos Experts en Développement</span>
    </h1>
    <p class="hero-description">
      Vous avez un projet de développement web, mobile ou une problématique d'intégration IA ? Rencontrons-nous pour un échange technique et stratégique.
    </p>
  </div>
</section>

<section class="section">
  <div class="container">
    <div style="display: flex; justify-content: center; flex-wrap: wrap; gap: 4rem;">
      
      <!-- Left side: Content -->
      <div style="flex: 1; min-width: 300px; max-width: 500px;">
        <h2>Pourquoi échanger avec nous ?</h2>
        <p class="mb-4">
          Choisir Mesh Box, c'est s'assurer d'un partenaire technique capable de comprendre vos enjeux business tout en maîtrisant les complexités de l'architecture logicielle moderne.
        </p>
        <ul class="check-list mb-8">
          <li><strong>Expertise Senior :</strong> Vos interlocuteurs sont des développeurs seniors (Node.js, Angular, Android).</li>
          <li><strong>Proximité :</strong> Présence physique à Paris et Châteauroux.</li>
          <li><strong>Impact Fiscal :</strong> Prestations éligibles au Crédit Impôt Innovation (CII).</li>
          <li><strong>Audit Gratuit :</strong> 30 minutes offertes pour diagnostiquer votre besoin.</li>
        </ul>
        <h3>Une question technique urgente ?</h3>
        <p>
          Nos experts interviennent également en mode "sauvetage" pour les applications en production subissant des crashs critiques ou des lenteurs inexpliquées. N'attendez pas que votre chiffre d'affaires soit impacté.
        </p>
      </div>

      <!-- Right side: Contact Form -->
      <div class="card" style="padding: 2.5rem; width: 100%; max-width: 600px; box-shadow: var(--shadow); border: 1px solid var(--border);">
        <h2 style="margin-bottom: 0.5rem;">Envoyez-nous un message</h2>
        <p style="margin-bottom: 2rem; color: var(--muted); font-size: 0.9rem;">
          Nous vous garantissons une réponse sous 24h ouvrées.
        </p>
        
        <form (ngSubmit)="handleSubmit()" #contactForm="ngForm" style="display: grid; gap: 1.5rem;">
          <div>
            <label for="name" style="display: block; margin-bottom: 0.5rem; font-weight: 600;">Nom complet</label>
            <input 
              type="text" 
              id="name" 
              name="name" 
              [(ngModel)]="formData.name" 
              placeholder="Ex: Jean Dupont"
              style="width: 100%; padding: 0.8rem; border-radius: 4px; border: 1px solid var(--border); background: var(--bg); color: var(--text);"
            />
          </div>

          <div>
            <label for="email" style="display: block; margin-bottom: 0.5rem; font-weight: 600;">Email professionnel *</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              required
              [(ngModel)]="formData.email" 
              placeholder="Ex: jean@entreprise.com"
              style="width: 100%; padding: 0.8rem; border-radius: 4px; border: 1px solid var(--border); background: var(--bg); color: var(--text);"
            />
          </div>

          <div>
            <label for="message" style="display: block; margin-bottom: 0.5rem; font-weight: 600;">Votre projet ou besoin technique *</label>
            <textarea 
              id="message" 
              name="message" 
              required
              rows="5"
              [(ngModel)]="formData.message" 
              placeholder="Décrivez brièvement votre problématique..."
              style="width: 100%; padding: 0.8rem; border-radius: 4px; border: 1px solid var(--border); background: var(--bg); font-family: inherit; color: var(--text);"
            ></textarea>
          </div>

          <div *ngIf="status().message" [style]="{
            padding: '1rem',
            borderRadius: '4px',
            background: status().type === 'success' ? 'rgba(76, 175, 80, 0.1)' : 'rgba(244, 67, 54, 0.1)',
            color: status().type === 'success' ? '#4caf50' : '#f44336',
            border: '1px solid ' + (status().type === 'success' ? '#4caf50' : '#f44336')
          }">
            {{ status().message }}
          </div>

          <button
            type="submit"
            [disabled]="isSubmitting()"
            class="button primary large"
            [style.cursor]="isSubmitting() ? 'not-allowed' : 'pointer'"
            [style.opacity]="isSubmitting() ? '0.7' : '1'"
            style="width: 100%;"
          >
            {{ isSubmitting() ? 'Envoi en cours...' : 'Envoyer le message' }}
          </button>

          <div style="text-align: center; color: var(--muted); font-size: 0.9rem; margin-top: 1rem;">
            Ou planifiez directement une visio de 15 min :
          </div>

          <app-cal-com-widget
            [buttonText]="'📅 Prendre rendez-vous avec un expert'"
            [calLink]="'https://cal.mesh-box.fr'"
            [username]="'ogirodin'"
            [eventType]="'15min'"
            style="width: 100%; justify-content: center;"
          ></app-cal-com-widget>

        </form>
      </div>

    </div>
  </div>
</section>

<section class="section alt">
   <div class="container">
      <h2 style="text-align: center; margin-bottom: 3rem;">Nos implantations physiques</h2>
      <div class="grid-2 gap-12">
         <div class="card p-8 bg-card text-center">
            <h3>Paris (75)</h3>
            <p><strong>Siège social et Relation Client</strong><br/>6 rue d'Armaillé<br/>75017 Paris</p>
         </div>
         <div class="card p-8 bg-card text-center">
            <h3>Châteauroux (36)</h3>
            <p><strong>Pôle de Production Technique</strong><br/>72 rue Louis Lumière<br/>36000 Châteauroux</p>
         </div>
      </div>
       <p style="margin-top: 3rem; text-align: center; font-size: 1.2rem;">
         Email direct : <a href="mailto:contact&#64;mesh-box.fr" style="color: var(--brand); font-weight: bold;">contact&#64;mesh-box.fr</a>
      </p>
      <div class="mt-8 flex justify-center">
        <app-cii-badge variant="compact" />
      </div>
   </div>
</section>